import React from 'react';
import cn from 'classnames';
import { RichTextContent } from './RichTextBlock';
import { findByType } from '../utils';
import { CTALink } from './CTABlock';
import './CardsBlock.scss';
export function CardsBlock({ data }) {
    var _a, _b;
    const cardStyle = (_a = findByType(data.value.config, 'card_style')) === null || _a === void 0 ? void 0 : _a.value;
    const styleClass = cardStyle ? `card_style_${cardStyle}` : undefined;
    const cardSize = (_b = findByType(data.value.config, 'card_size')) === null || _b === void 0 ? void 0 : _b.value;
    return (React.createElement("div", { className: cn('content-block-cards', styleClass), style: { '--card-size': cardSize } }, data.value.cards.map((card, i) => React.createElement(CardBlock, { key: i, data: card }))));
}
export function CardBlock({ data }) {
    const [cta] = data.ctaBlock;
    return React.createElement("div", { className: "content-block-card" },
        React.createElement(RichTextContent, { html: data.text }),
        cta ? React.createElement(CTALink, { link: cta }) : null);
}
